import { map, isArray } from 'lodash';
import React from "react";
import renderRawHtml from "./render_raw_html";

const prepareText = ({ texts, type }) => {
  if (!isArray(texts)) {
    return (<p { ...renderRawHtml(texts) } />);
  }
  return (
    (!!type && type === "list") ?
      (
        <ul>
          {
            map(texts, (text, idx) => (
              <li key={ `li-${idx}` } { ...renderRawHtml(text) } />
            ))
          }
        </ul>
      ) :
      (
        map(texts, (text, idx) => (
          <p key={ `p-${idx}` } { ...renderRawHtml(text) } />
        ))
      )
  );
};

export { prepareText };